import { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";

import TipoSolicitacao from "../../../../lib/json/consultas/TipoSolicitacao.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";

function ListaTipoSolicitacao(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = TipoSolicitacao.tabelas;
    
    const navigate = useNavigate();
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("tipoSolicitacaoEmpresa", {value: "",text: "", });


    // Colunas do grid
    const columns = [
        {
          Header: 'Filial',
          accessor: "PSC_FILIAL",
        },
        {
          Header: 'ID',
          accessor: "PSC_ID"
        },
        {
          Header: 'Descrição',
          accessor: "PSC_DESC"
        },
        {
          Header: 'Tipo Título',
          accessor: 'PSC_TIPO',
          Cell: (item) => { return item.value + ' - ' + item.row.original.X5_DESCRI}
        },
        {
          Header: 'Prefixo',
          accessor: 'PSC_PREFIX'
        }
    ];

    // Processa consulta do grid
    const listaTipoSolicitacao = async () => {
        var consultaDefault = TipoSolicitacao.consulta;
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta){
            setData(retConsulta.data);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaTipoSolicitacao()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.PSC_ID}/${row.original.EMPRESA}${row.original.PSC_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.PSC_ID}/${row.original.EMPRESA}${row.original.PSC_FILIAL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.PSC_FILIAL + '|' + row.original.PSC_ID;
        const Mensagem = `Tem certeza que deseja excluir o Tipo de Solicitação ${row.original.PSC_ID + ' - da Filial: ' + row.original.PSC_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { PSC_ID: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRTIPOSOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error == '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaTipoSolicitacao();
        }
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Tipo de Solicitação de Pagamento"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaTipoSolicitacao}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote" }, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" }
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaTipoSolicitacao;